import { DebounceSearchInput } from '@checkit/react-components';
import React, {FC} from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

type InputChangeHandler = (value: string | null) => void;

interface Props {
  onNameChange: InputChangeHandler;
  initialName: string;
}

const messages = defineMessages({
  'checkpoints.search.namePlaceholder': {
    defaultMessage: 'Filter by name',
    id: 'checkpoints.search.namePlaceholder'
  }
});

const NameFilter: FC<Props> = (props: Props) => {
  const {initialName, onNameChange} = props;
  const {formatMessage} = useIntl();
  const onInputChange = (term: string | null) => {
    onNameChange(term);
  };

  return (
    <DebounceSearchInput
      defaultValue={initialName}
      fullWidth={true}
      id={'nameFilter'}
      name={'nameFilter'}
      placeholder={formatMessage(messages['checkpoints.search.namePlaceholder'])}
      onSearchTermChanged={onInputChange}
    />
  );
};

export default NameFilter;
